export const LAYER_1_TOKENS = ['eth', 'bnb']